module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAN4AAAABCAYAAACxDxBNAAAAAXNSR0IArs4c6QAAACRJREFUOE9j/Bvi958BDTCv2cSILjaqjoFhNFwYGEbTAXXSAQAcx1qg1QeZXwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/common/images/productCenter/A2/bline1.png
// module id = G6je
// module chunks = 0